attachEvent('[data-mode-switch]', 'click', (ev) => {
  const inputs = document.querySelectorAll('[data-mode-input]');
  inputs.forEach((el) => {
    el.checked = !el.checked;
  });
  document.body.classList.toggle('is-dark-mode');
  ev.preventDefault();
});

const checkScrollPosition = () => {
  const scrollY = window.scrollY || window.pageYOffset;
  document.body.classList.toggle('show-modes-button', scrollY >= 400);
};

window.addEventListener('scroll', checkScrollPosition);
window.addEventListener('load', checkScrollPosition);
